<template>
  <div class="dialog" :class="cssType" v-if="props.modelValue">
    <div class="dialog-mask"></div>
    <div class="dialog-content" :class="type">
      <div class="dialog-title" :class="type + ' ' + locale"></div>
      <slot></slot>
      <div class="dialog-close" :class="type" @click="handleClose"></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  type: { // validateUser, rewards, rewards-all , record
    type: String,
    required: true
  }
})

watch(() => props.modelValue, (newVal) => {
  if (props.type === 'record') {
    if (newVal) {
      document.body.classList.add('lock-scroll')
    } else {
      document.body.classList.remove('lock-scroll')
    }
  }
}, { immediate: true })

const emit = defineEmits(['update:modelValue'])

const handleClose = () => {
  emit('update:modelValue', false)
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>